import Color from '../Color.mjs'
import superMeta from '../_PSEUDO/metaPseudoNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    name: '表主键',
    textProp: 'dfName',
    type: 'PK',
}
